export const PAGE_CHANGE = 'pageChange';
export const SEARCH_CHANGE = 'searchChange';
export const FILTER_CHANGE = 'filterChange';

export type AdminActionType =
  | typeof PAGE_CHANGE
  | typeof SEARCH_CHANGE
  | typeof FILTER_CHANGE;
